import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus, X, UserPlus, MessageSquarePlus, Plane, UserRound } from 'lucide-react';
import NewLeadDialog from '@/components/lead/NewLeadDialog';
import { invalidate } from '../lib/cache';

const ACTIONS = [
  { key: 'lead', label: 'Lead', icon: UserPlus, testid: 'm-fab-lead' },
  { key: 'enquiry', label: 'Enquiry', icon: MessageSquarePlus, to: '/quotes/new', testid: 'm-fab-enquiry' },
  { key: 'trip', label: 'Trip', icon: Plane, to: '/itineraries/new', testid: 'm-fab-trip' },
  { key: 'traveller', label: 'Traveller', icon: UserRound, to: '/clients/new', testid: 'm-fab-traveller' },
];

/**
 * Mobile FAB — bottom-right (above bottom nav). Quick Add: Lead / Enquiry /
 * Trip / Traveller. "Lead" opens the capture dialog inline; the rest push the
 * matching (reused) builder screens.
 */
export const MobileFab = ({ onLeadCreated }) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [leadOpen, setLeadOpen] = useState(false);

  const pick = (a) => {
    setOpen(false);
    if (a.key === 'lead') { setLeadOpen(true); return; }
    navigate(a.to);
  };

  return (
    <>
      {open && (
        <button type="button" aria-label="Close" onClick={() => setOpen(false)} data-testid="m-fab-backdrop" className="fixed inset-0 z-40 bg-black/25" />
      )}
      <div className="fixed right-4 z-50 flex flex-col items-end gap-2.5" style={{ bottom: 'calc(80px + env(safe-area-inset-bottom))' }}>
        {open && (
          <div className="flex flex-col items-end gap-2 mb-1" data-testid="m-fab-menu">
            {ACTIONS.map((a) => {
              const Icon = a.icon;
              return (
                <button key={a.key} type="button" onClick={() => pick(a)} data-testid={a.testid}
                  className="flex items-center gap-2.5 bg-white border border-[#E5E7EB] rounded-lg pl-3.5 pr-2 py-2 min-h-[44px] active:bg-[#F8F9FA]">
                  <span className="text-[14px] font-medium text-[#111827]">{a.label}</span>
                  <span className="w-8 h-8 rounded-lg flex items-center justify-center text-white" style={{ backgroundColor: '#0F6E56' }}><Icon className="h-4 w-4" /></span>
                </button>
              );
            })}
          </div>
        )}
        <button type="button" onClick={() => setOpen((o) => !o)} data-testid="m-fab"
          aria-label={open ? 'Close quick add' : 'Quick add'}
          className="w-14 h-14 rounded-full flex items-center justify-center text-white active:scale-95 transition-transform"
          style={{ backgroundColor: '#0F6E56' }}>
          {open ? <X className="h-6 w-6" /> : <Plus className="h-7 w-7" />}
        </button>
      </div>

      <NewLeadDialog
        open={leadOpen}
        onOpenChange={setLeadOpen}
        onCreated={() => { setLeadOpen(false); invalidate('/api/website-leads'); onLeadCreated?.(); }}
      />
    </>
  );
};

export default MobileFab;
